<div class="file-input-wrapper">
  <div
    class="upload-container"
    (click)="!disabled() && inputElement.click()"
    appDnd
    (fileDropped)="handleDragAndDrop($event)"
    [class.disabled]="disabled()"
    [class.error]="error()">
    <mat-icon class="upload-icon mb-2" [svgIcon]="'upload'"></mat-icon>
    <div class="font-label-large mb-3">
      {{ description() }}
    </div>
    <div class="font-caption-default font-medium upload-size-text" i18n>Up to {{ FileUtils.maxFileSizeInMB }} MB</div>
  </div>
  <input
    type="file"
    hidden
    #inputElement
    [accept]="accept()"
    (change)="handleInputChange($event)"
    [attr.id]="controlId()"
    [multiple]="multiple()" />
</div>
